module.exports = __webpack_public_path__ + "img/program-day-active.7112ebcb.svg";